<div class="boxed-border">
  <div class="title row">
    <span>
      MG Earning Details
    </span>
    <span class="pull-right">
      <div class="row">
        <div style="color: black;">
          <div class="row margin-right-12 align-icons">
            <fa-icon class="cursor-pointer margin-icons" (click)="refreshData()" [icon]="faRefresh"></fa-icon>
            <input type="date" [value]="selectedDate" (change)="onDateChange($event.target['value'])"
              style="border: 1px solid #ccc; border-radius: 4px; padding: 2px 6px; font-size: 13px;">
          </div>
        </div>
      </div>
    </span>
  </div>
  <div class="line"></div>
  <div class="scrollable-y">

    <div *ngIf="mgShiftGroups.length === 0" style="padding: 20px; text-align: center; color: #888;">
      No data found
    </div>

    <div *ngFor="let group of mgShiftGroups" class="padding-bottom-10">
      <table class="table table-bordered" style="margin-bottom: 0;">
        <thead>
          <tr>
            <th style="width: 40%;">FIELD</th>
            <th>DETAILS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Shift name</td>
            <td><strong>{{ group.shiftName }}</strong></td>
          </tr>
          <tr>
            <td>MG slot</td>
            <td>
              <div *ngFor="let slot of group.slots">
                <strong>{{ formatMgSlot(slot) }}</strong>
              </div>
              <span *ngIf="!group.slots || group.slots.length === 0">-</span>
            </td>
          </tr>
          <tr>
            <td>City</td>
            <td><strong>{{ group.cityName }}</strong></td>
          </tr>
          <tr>
            <td>Rides goal</td>
            <td><strong>{{ group.ridesGoal }} rides</strong></td>
          </tr>
          <tr>
            <td>MG earning on goal</td>
            <td><strong style="color: #2e7d32;">&#8377;{{ group.mgAmount }}</strong></td>
          </tr>
          <tr>
            <td>Achievement status</td>
            <td>
              <span *ngIf="group.achievementStatus === 'achieved'" class="label label-success">MG goal achieved</span>
              <span *ngIf="group.achievementStatus === 'in_progress'" class="label label-warning">In progress</span>
              <span *ngIf="group.achievementStatus === 'not_achieved'" class="label label-danger">MG goal not achieved</span>
              <span *ngIf="group.achievementStatus === 'not_started'" class="label label-default">Not started</span>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table table-bordered" style="margin-bottom: 0;">
        <thead>
          <tr class="active">
            <th colspan="2">GOAL PROGRESS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 40%;">Rides completed</td>
            <td>
              <div style="display: flex; align-items: center; gap: 12px;">
                <div style="flex: 1; background: #e0e0e0; border-radius: 4px; height: 8px; max-width: 200px;">
                  <div [style.width.%]="getProgressPercent(group.completedOrders, group.ridesGoal)"
                       style="background: #388e3c; height: 8px; border-radius: 4px;"></div>
                </div>
                <span>{{ group.completedOrders }} of {{ group.ridesGoal }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table class="table table-bordered" style="margin-bottom: 16px;">
        <thead>
          <tr class="active">
            <th colspan="5">ORDERS UNDER MG SLOT</th>
          </tr>
          <tr>
            <th>ORDER ID</th>
            <th>PICKUP TIME</th>
            <th>DROP TIME</th>
            <th>RIDE EARNING</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of group.orders" class="cursor-pointer" (click)="openOrderDetails(order.orderId)">
            <td><strong>{{ order.orderId }}</strong></td>
            <td>{{ formatTimestamp(order.pickupTime) }}</td>
            <td>{{ formatTimestamp(order.dropTime) }}</td>
            <td><strong style="color: #2e7d32;">&#8377;{{ order.earning }}</strong></td>
            <td>
              <button class="btn btn-default btn-sm" (click)="$event.stopPropagation(); openOrderDetails(order.orderId)">View ›</button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="2"><strong>Total ({{ group.orders.length }} orders)</strong></td>
            <td></td>
            <td><strong style="color: #2e7d32;">&#8377;{{ group.totalEarning }}</strong></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>
